var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5032 4.61099C23.2556 4.12834 21.4999 2.37261 21.0172 0.125C20.5346 2.37261 18.7789 4.12834 16.5312 4.61099C18.7789 5.09364 20.5346 6.84937 21.0172 9.09698C21.4999 6.84937 23.2556 5.09364 25.5032 4.61099ZM10.0013 1.8916C11.0236 6.65204 14.7422 10.3707 19.5027 11.3929C14.7422 12.4152 11.0236 16.1338 10.0013 20.8943C8.97909 16.1338 5.26044 12.4152 0.5 11.3929C5.26044 10.3707 8.97909 6.65204 10.0013 1.8916ZM21.134 14.667C21.496 16.3527 22.8128 17.6695 24.4985 18.0315C22.8128 18.3935 21.496 19.7103 21.134 21.396C20.772 19.7103 19.4552 18.3935 17.7695 18.0315C19.4552 17.6695 20.772 16.3527 21.134 14.667Z",
    fill: "url(#paint0_linear_3642_14522)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3642_14522",
    x1: 2.96244,
    y1: 21.396,
    x2: 23.0408,
    y2: 21.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F34EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B4BDA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePage1);
export default __webpack_public_path__ + "static/media/HomePage1.59d86b94429e7f627c127a35650126c7.svg";
export { ForwardRef as ReactComponent };